import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import CssBaseline from '@material-ui/core/CssBaseline';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import { store } from './redux/store';
// import { LicenseManager }  from 'ag-grid-enterprise';
import {
  BrowserRouter,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import { rootRoutes } from './pages/rootRoutes';

//LicenseManager.setLicenseKey(
//  'For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-7_May_2022_[v2]_MTY1MTg3ODAwMDAwMA==e7069277fe152a0bfac889f53777976e'
//);

// import AppointmentContextProvider from "./component/FhirComponents/template/appointmentNew/context/AppointmentContextProvider";
// 0 no logging
// 1 normal
// 2 warning
// 3 normal plus warning
// 4 error
// 5 normal plus error
// 6 error plus warning
// 7 normal.plus warning plus error

let logLevelDisable = {
  log: [0, 2, 4, 6],
  warn: [0, 1, 4, 5],
  error: [0, 1, 2, 3],
};

const disableAllLogs = () => {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.assert = () => {};
};

if (!localStorage.getItem('logs')) {
  disableAllLogs();
} else {
  let logLevel = Number(localStorage.getItem('logs'));
  if (!isNaN(logLevel)) {
    Object.keys(logLevelDisable).forEach(n => {
      if (logLevelDisable[n].includes(logLevel)) {
        console[n] = () => {};
      }
    });
  } else {
    disableAllLogs();
  }
}

ReactDOM.render(
  <React.Fragment>
    <CssBaseline />
    <Provider store={store}>
      <RouterProvider router={rootRoutes} />
      {/* <BrowserRouter>
        <App />
      </BrowserRouter> */}
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
